/**
 * Debounce duration for invoking the `scrollEnd()`.
 * This must not be less than the native scroll interval.
 *
 * @since 0.1.0
 */
export const SCROLL_END_DEBOUNCE_DURATION = 60;

/**
 * The number of lines for margin.
 *
 * @since 0.1.0
 */
export const MARGIN_LINES = 10;
